import { connect } from 'react-redux'
import { RestaurantComponent } from './RestaurantComponent'
import { fetchCoupons, fetchRestaurantPageData } from 'shared/store/restaurant'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => {
    const { restaurantPageState, storeLocatorPageState } = state
    return {
        ...restaurantPageState,
        userPosition: storeLocatorPageState.userPosition
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchPageData: async (restaurantPath: string) => {
        const data = await d(fetchRestaurantPageData(restaurantPath))

        if (data?.restaurant?.id) {
            d(fetchCoupons({ restaurantId: data.restaurant.id }))
        }
    }
})

const Restaurant = connect(
    mapStateToProps,
    mapDispatchToProps
)(RestaurantComponent)

export { Restaurant }
